// extracted by mini-css-extract-plugin
export default {"deckLoaderContainer":"DeckLoader_deckLoaderContainer__q4jzU","deckContent":"DeckLoader_deckContent__fAlya"};